<template>
    <div id="section" class="Section">  

        <model-viewer :src="'static/'+ model +'.glb'" 
            :ios-src="'static/'+ model +'.usdz'"
            ar 
            ar-modes="webxr scene-viewer"
            auto-rotate
            camera-controls 
            shadow-intensity="1" 
            alt="Julien">         
        </model-viewer>


        <div class="Section__button" @click="onClick()">Click to play Sound ... </div>


    </div>
</template>

<script> 

import {Howl, Howler} from 'howler'
import Mixin from '@/mixins/Smooth.js'

export default {

    name: 'Section',
    mixins: [Mixin],
    data: () => ({
        width: window.innerWidth,
        height: window.innerHeight,
        model: null
    }),
    computed: {
        // artwork_used() {
        //   return this.$store.getters['app/artwork_used']
        // }
    },
    mounted() {
        this.model = this.$route.params.id ? this.$route.params.id : 'julien'
        console.log(this.model);


        this.$sound = new Howl({
            src: [require('./audio/sound.mp3')],
            loop: true
        });

        // sound.play();


    },
    methods: {  
        onClick() {
            this.$sound.play()
        },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'
@import '~@/commons/stylus/Hamburger-icon'

.Section 
    color black
    display flex
    position fixed
    top 0
    left 0
    width 100vw
    height 100%

    // background-color red


    &__button 
        width 100%
        height 60px 
        background rgba(black, .8)
        position absolute
        color white
        display flex 
        align-items center
        padding-left 20px



model-viewer 
    width 100%
    height 90%
    background-color transparent

       
</style>


